import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import Logo from '../../assets/images/logo.png'

const Header1 = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [activePage, setActivePage] = useState('');
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        // Get the current page path from window.location
        const currentPath = window.location.pathname;
        // Remove the leading slash and set as active page
        const current = currentPath.replace('/', '') || 'home';
        setActivePage(current);

        const handleScroll = () => {
            // Update header style when scrolled
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Navigation Items with direct URLs
    const navItems = [
        { id: 'home', label: 'Home', url: '/' },
        { id: 'services', label: 'Services', url: '/#services' },
        // { id: 'about', label: 'About Us', url: '/about' },
        { id: 'pricing', label: 'Pricing', url: '/#pricing' },
        { id: 'testimonials', label: 'Testimonials', url: '/#testimonials' },
        { id: 'contact', label: 'Contact', url: '/#contact' }
    ];

    return (
        <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled
            ? 'bg-white shadow-md py-2'
            : 'bg-transparent py-4'
            }`}>
            <div className="container mx-auto px-4">
                <nav className="flex items-center justify-between">
                    <div className="flex items-center">
                        <div className="mr-6">
                            <div className="cursor-pointer" onClick={() => window.location.href = '/'}>
                                <img
                                    src={Logo}
                                    alt="Sparkle Xxpress Logo"
                                    loading="lazy"
                                    className={`h-10 transition-all duration-300 ${isScrolled ? 'h-10' : 'h-12'}`}
                                />
                            </div>
                        </div>

                        <ul className="hidden md:flex space-x-8">
                            {navItems.map(item => (
                                <li key={item.id}>
                                    <a
                                        href={item.url}
                                        className={`font-medium transition-colors duration-300 ${activePage === item.id
                                            ? isScrolled ? 'text-blue-700' : 'text-blue-300'
                                            : isScrolled ? 'text-gray-700 hover:text-blue-700' : 'text-gray-700 hover:text-blue-700'
                                            }`}
                                    >
                                        {item.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="hidden md:flex items-center space-x-4">
                        <a
                            href="/"
                            className={`px-5 py-2 rounded-full font-medium transition-colors duration-300 ${isScrolled
                                ? 'bg-blue-600 text-white hover:bg-blue-700'
                                : 'bg-blue-500 text-white hover:bg-blue-600'
                                }`}
                        >
                            Download Our App
                        </a>
                    </div>
                    <button
                        className={`md:hidden transition-colors ${isScrolled ? 'text-gray-700' : 'text-white'
                            }`}
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                    >
                        {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </nav>
            </div>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <div className="md:hidden bg-white shadow-lg">
                    <ul className="py-4 px-6 space-y-4">
                        {navItems.map(item => (
                            <li key={item.id}>
                                <a
                                    href={item.url}
                                    className={`block font-medium ${activePage === item.id ? 'text-blue-700' : 'text-gray-700'}`}
                                    onClick={() => setIsMenuOpen(false)}
                                >
                                    {item.label}
                                </a>
                            </li>
                        ))}
                        <li className="pt-4">
                            <a
                                href="/"
                                className="w-full px-5 py-2 bg-blue-600 text-white rounded-full font-medium hover:bg-blue-700 transition-colors block text-center"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                Download Our App
                            </a>
                        </li>
                        <li>
                            <a
                                href="/#contact"
                                className="w-full px-5 py-2 border border-blue-600 text-blue-600 rounded-full font-medium hover:bg-blue-600 hover:text-white transition-colors block text-center"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                Contact Us
                            </a>
                        </li>
                    </ul>
                </div>
            )}
        </header>
    );
};

export default Header1;